/**
 * Social-preview (Open Graph / Twitter Card) constants, shared by the
 * root layout's site-level meta (`app/_layout.tsx`), the public
 * deal-landing page's per-deal meta (`lib/dealOg.ts`) and the server
 * middleware that answers crawlers (`lib/linkPreview.ts`).
 */

/** A leading space plus U+2014. Typing a hyphen here ships a wrong share card. */
export const OG_TITLE_SUFFIX = ' — MarketPryce';

/**
 * Public origin used for OG image URLs and other absolute meta URLs.
 * Baked into the JS bundle at build time. In production `eas.json` sets
 * EXPO_PUBLIC_APP_BASE_URL for the production profile; dev / preview
 * fall back to the prod origin when it isn't set.
 *
 * Trailing slash stripped so `${APP_BASE_URL}/${slug}` can't emit a double
 * slash.
 */
export const APP_BASE_URL = (
  process.env.EXPO_PUBLIC_APP_BASE_URL ?? 'https://app.marketpryce.com'
).replace(/\/$/, '');

/**
 * Always the MP umbrella monogram, never a brand logo. Brand logos in
 * prod are SVG, and iMessage / Twitter / Facebook don't render SVG OG
 * images — picking one would force scrapers to fall back to the compact
 * thumbnail card instead of the large layout. The title carries the
 * brand verbally instead.
 */
export const DEFAULT_OG_IMAGE = `${APP_BASE_URL}/og-image.png`;

/** Site-level title, used when no deal is in scope. */
export const DEFAULT_OG_TITLE = 'MarketPryce — Get paid for signing up';

/**
 * Site-level description. NOT a per-deal fallback — a deal with no copy
 * falls back to its own `title`. See the note in `lib/dealOg.ts`.
 */
export const DEFAULT_OG_DESCRIPTION =
  'Get paid for opening accounts at brands you already use. MarketPryce turns banking signups into cash.';
